export default {
  "pager": "_pager_100pt_1",
  "pagerList": "_pagerList_100pt_11",
  "page": "_page_100pt_1",
  "activePage": "_activePage_100pt_20",
  "sizeArea": "_sizeArea_100pt_24",
  "wrapper": "_wrapper_100pt_28",
  "bottom": "_bottom_100pt_32",
  "pagedList": "_pagedList_100pt_36"
};import "ni:sha-256;Z44gruOzWUm2YlDqDKmsQrn83yechoAeKjUEfbyW8NU";